export default "__VITE_ASSET__BDu$GWhf__";